import { render } from "./SponsorListForm.vue?vue&type=template&id=40a1bcb3"
import script from "./SponsorListForm.vue?vue&type=script&lang=js"
export * from "./SponsorListForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__